export const HAS_DEBIT_NOTE_LINK_QUERY = {
  $or: [
    { debitNotes: { $exists: true, $not: { $size: 0 } } },
    { "debitNoteAssignments.0": { $exists: true } },
  ],
};

export function buildMatchingPaymentSearchQuery(bankAccountId, type = "PAYMENT") {
  return {
    bankAccount: bankAccountId,
    status: "MATCHING",
    amount: type === "REFUND" ? { $lt: 0 } : { $gt: 0 },
    ...HAS_DEBIT_NOTE_LINK_QUERY,
  };
}

export function clientPaymentApiError(resultOrError) {
  if (!resultOrError) return "Failed to update client payment";
  if (typeof resultOrError === "string") return resultOrError;
  if (resultOrError instanceof Error) {
    return resultOrError.message || "Failed to update client payment";
  }
  return (
    resultOrError.error?.message ||
    resultOrError.error ||
    resultOrError.message ||
    "Failed to update client payment"
  );
}

export function assertClientPaymentHasAssignments(values) {
  if (!values?.debitNoteAssignments || values.debitNoteAssignments.length === 0) {
    throw new Error(
      "Client payment must be assigned to at least one debit note. Delete the payment instead.",
    );
  }
}
